// eslint-disable-next-line
import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Autonomy from './views/Autonomy.vue';
Vue.use(Router);

export default new Router({
  mode: 'history',
  hashbang: false,
  linkActiveClass: 'active',

  routes: [
    {
      path: '*',
      name: 'Landing',
      component: Home
    },
    {
      path: '/',
      name: 'Landing',
      component: Home
    },
    {
      path: '/:lang?/:country?/',
      name: 'Home',
      component: Home
    },
    {
      path: '/:lang/:country/autonomy',
      name: 'Autonomy',
      component: Autonomy
    }
  ]
});
